


<h2 mat-dialog-title class="modal-title">Add New Client</h2>
  <form [formGroup]="billingForm">
<mat-dialog-content class="form-grid">
  <!-- Row 1 -->
  <div class="form-item">
    <app-lbn-input-field
      [formGroup]="billingForm"
      label="Client Name"
      controlName="clientName"
      placeholder="Enter company name">
    </app-lbn-input-field>
  </div>

  <div class="form-item">
    <app-data-picker
      [label]="'Registration Date'"
      [form]="billingForm"
      controlName="registrationDate"
      [maxDate]="today">
    </app-data-picker>
  </div>

  <!-- Row 2 -->
  <div class="form-item">
    <app-lbn-input-field
      [formGroup]="billingForm"
      label="Employee Head Count Limit"
      controlName="activeEmployees"
      placeholder="Enter Amount"
      inputType="numeric">
    </app-lbn-input-field>
  </div>
   <div class="form-item">
    <app-lbn-input-field
      [formGroup]="billingForm"
      label="CMS Fin Number"
      controlName="cmsFinNumber"
      placeholder="Enter Amount"
      inputType="numeric">
    </app-lbn-input-field>
  </div>

  <div class="form-item">
    <app-input-dropdown
      [label]="'Branch'"
      [formGroup]="billingForm"
      controlName="branch"
      [options]="branches"
      (selectionChange)="onCategorySelect($event)">
    </app-input-dropdown>
  </div>
</mat-dialog-content>



 <mat-dialog-actions align="end" class="dialog-actions">
  <app-form-actions-buttons [buttons]="updateButtons"></app-form-actions-buttons>
</mat-dialog-actions> 
</form>